import { Timer, Warehouse, Play, Square, AlertTriangle } from 'lucide-react';
import { LEG_COLORS, dur } from './helpers';
import { useI18nStore } from '../../lib/i18n';
const tt = (k, p) => useI18nStore.getState().t(`startStopAdmin.${k}`, p);

const Stop = ({ icon: Icon, label, time, testId }) => (
  <div className="text-center min-w-0" data-testid={testId}>
    <div className="mx-auto h-8 w-8 rounded-full bg-slate-900 text-white flex items-center justify-center"><Icon className="h-4 w-4" /></div>
    <div className="text-base font-black tabular-nums mt-1">{time || '—'}</div>
    <div className="text-[10px] text-slate-500 truncate">{label}</div>
  </div>
);
const Gap = ({ color, min }) => (
  <div className="flex-1 flex flex-col items-center pt-3 min-w-[44px]">
    <span className="h-1 w-full rounded-full" style={{ background: color }} />
    <span className="text-[10px] font-bold tabular-nums mt-1" style={{ color }}>{min == null ? '—' : tt('nMin', { m: min })}</span>
  </div>
);

export function WorkTimeline({ w, r }) {
  if (!w) return null;
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 p-3 space-y-3" data-testid="ss-work-timeline">
      <div className="flex items-start gap-1">
        <Stop icon={Warehouse} label={tt('departDepot')} time={w.depart_at} testId="ss-wt-depart" />
        <Gap color={LEG_COLORS.depot_start} min={w.drive_out_min} />
        <Stop icon={Play} label="Start" time={r.start?.entered_time} testId="ss-wt-start" />
        <Gap color={LEG_COLORS.start_stop} min={w.tour_min} />
        <Stop icon={Square} label="Stop" time={r.stop?.entered_time} testId="ss-wt-stop" />
        <Gap color={LEG_COLORS.stop_depot} min={w.drive_back_min} />
        <Stop icon={Warehouse} label={tt('returnDepot')} time={w.return_at} testId="ss-wt-return" />
      </div>
      <div className="rounded-lg bg-slate-900 text-white px-3 py-2.5 flex items-center justify-between" data-testid="ss-wt-total">
        <span className="text-xs text-slate-300 flex items-center gap-1.5"><Timer className="h-4 w-4" />{tt('workTotal')}</span>
        <span className="text-2xl font-black tabular-nums">{dur(w.work_total_min)}</span>
      </div>
      <p className="text-[10px] text-slate-500">{tt('workFormula')}</p>
      {(w.legs_estimated || !w.has_depot) && (
        <p className="text-[10px] text-amber-700 flex items-center gap-1"><AlertTriangle className="h-3 w-3" />{tt(w.has_depot ? 'workEstimated' : 'workNoDepot')}</p>
      )}
    </div>
  );
}
